import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  FormField,
  FormGroup,
  Checkbox,
  Dropdown
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardVerbalOrderHistoryUX = (props: any) => {
    return(
      <div
        id="CardVerbalOrderHistoryUX-div-0"
        style={{height: "100%", width: "100%"}}>
        <Form
          id="CardVerbalOrderHistoryUX-Form-1">
          <FormField
            id="CardVerbalOrderHistoryUX-FormField-2"
            inline={true}
            width="16">
            <label
              id="CardVerbalOrderHistoryUX-label-3"
              style={{fontSize: "16px", padding :"10px"}}>
              {props.languageUX === "en" ? "History of Verbal Order" : "ประวัติ รคส."}
            </label>
          </FormField>
          <FormGroup
            id="CardVerbalOrderHistoryUX-FormGroup-4"
            inline={true}>
            <div
              className={props.haveEncounter ? "" : "one wide field"}
              id="CardVerbalOrderHistoryUX-div-50"
              style={{display: props.haveEncounter? "none": "block"}}>
              
              <Dropdown
                fluid={true}
                id="CardVerbalOrderHistoryUX-Dropdown-53"
                onChange={props.changeSelectedSearch}
                options={props.optionsSearch}
                selection={true}
                style={{display: props.haveEncounter?  "none": "block"}}
                value={props.selectedSearch}>
              </Dropdown>
            </div>
            <div
              className={props.haveEncounter ? "" : "three wide field"}
              id="CardVerbalOrderHistoryUX-div-51"
              style={{display: props.haveEncounter? "none": "block"}}>
              
              <div
                id="CardVerbalOrderHistoryUX-div-52"
                style={{width: "100%", display: props.haveEncounter?  "none": "block"}}>
                {props.optionSearch}
              </div>
            </div>
            <FormField
              id="CardVerbalOrderHistoryUX-FormField-38"
              width="1">
              <div
                id="CardVerbalOrderHistoryUX-div-39"
                style={{width: "100%",textAlign: "center",}}>
                {props.languageUX === "en" ? "Recorder" : "ผู้บันทึก"}
              </div>
            </FormField>
            <FormField
              id="CardVerbalOrderHistoryUX-FormField-7"
              width="3">
              <div
                id="CardVerbalOrderHistoryUX-div-12"
                style={{width: "100%"}}>
                {props.editorSearch}
              </div>
            </FormField>
            <FormField
              id="CardVerbalOrderHistoryUX-FormField-40"
              width="1">
              <div
                id="CardVerbalOrderHistoryUX-div-41"
                style={{textAlign: "center", width: "100%"}}>
                {props.languageUX === "en" ? "Date" : "วันที่"}
              </div>
            </FormField>
            <FormField
              id="CardVerbalOrderHistoryUX-FormField-42"
              width="3">
              <div
                id="CardVerbalOrderHistoryUX-div-43"
                style={{ width: "100%"}}>
                
                <DateTextBox
                  id="CardVerbalOrderHistoryUX-DateTextBox-44"
                  onChange={props.onChangeStartDate}
                  value={props.startDate}>
                </DateTextBox>
              </div>
            </FormField>
            <FormField
              id="CardVerbalOrderHistoryUX-FormField-45"
              width="1">
              <div
                id="CardVerbalOrderHistoryUX-div-46"
                style={{textAlign: "center", width: "100%"}}>
                {props.languageUX === "en" ? "to" : "ถึง"}
              </div>
            </FormField>
            <FormField
              id="CardVerbalOrderHistoryUX-FormField-47"
              width="3">
              <div
                id="CardVerbalOrderHistoryUX-div-48"
                style={{width: "100%"}}>
                
                <DateTextBox
                  id="CardVerbalOrderHistoryUX-DateTextBox-49"
                  onChange={props.onChangeEndDate}
                  value={props.endDate}>
                </DateTextBox>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup
            id="CardVerbalOrderHistoryUX-FormGroup-14"
            inline={true}>
            <FormField
              id="CardVerbalOrderHistoryUX-FormField-30"
              width="7">
              <div
                id="CardVerbalOrderHistoryUX-div-31"
                style={{width: "100%", display: "flex", justifyContent: "space-evenly", alignItems: "center"}}>
                
                <Checkbox
                  checked={props.selectedOrder?.includes("ADMIT_ORDER")}
                  id="CardVerbalOrderHistoryUX-Checkbox-32"
                  label={props.languageUX === "en" ? "Admit" : "Admit"}
                  name="ADMIT_ORDER"
                  onChange={props.changeSelectedOrder}>
                </Checkbox>
                <Checkbox
                  checked={props.selectedOrder?.includes("DRUG_ORDER")}
                  id="CardVerbalOrderHistoryUX-Checkbox-33"
                  label={props.languageUX === "en" ? "Drug" : "ยา"}
                  name="DRUG_ORDER"
                  onChange={props.changeSelectedOrder}>
                </Checkbox>
                <Checkbox
                  checked={props.selectedOrder?.includes("LAB_ORDER")}
                  id="CardVerbalOrderHistoryUX-Checkbox-34"
                  label={props.languageUX === "en" ? "Lab" : "แล็บ"}
                  name="LAB_ORDER"
                  onChange={props.changeSelectedOrder}>
                </Checkbox>
                <Checkbox
                  checked={props.selectedOrder?.includes("TREATMENT_ORDER")}
                  id="CardVerbalOrderHistoryUX-Checkbox-35"
                  label={props.languageUX === "en" ? "Treatment" : "หัตถการ"}
                  name="TREATMENT_ORDER"
                  onChange={props.changeSelectedOrder}>
                </Checkbox>
                <Checkbox
                  checked={props.selectedOrder?.includes("OR_ORDER")}
                  id="CardVerbalOrderHistoryUX-Checkbox-36"
                  label={props.languageUX === "en" ? "Surgery" : "ผ่าตัด"}
                  name="OR_ORDER"
                  onChange={props.changeSelectedOrder}>
                </Checkbox>
              </div>
            </FormField>
            <FormField
              id="CardVerbalOrderHistoryUX-FormField-19"
              width="1">
              <div
                id="CardVerbalOrderHistoryUX-div-54">
                {props.buttonSearch}
              </div>
            </FormField>
          </FormGroup>
        </Form>
        <Table
          data={props.historyData}
          getTrProps={props.rowProps}
          headers="Patient,Order Date,Type,Status,Description,ผู้บันทึกคำสั่งแทน,co-signed,co-signed Time,หมายเหตุ,"
          id="CardVerbalOrderHistoryUX-Table-37"
          keys="patient_summary,created,order_specific_label,specific_status,description,order_receive_by_name,co_signed,co_signed_time,ack_comments,_action"
          minRows="10"
          showPagination={false}
          style={{maxHeight: "50vh"}}>
        </Table>
      </div>
    )
}


export default CardVerbalOrderHistoryUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Thu Nov 20 2025 07:17:09 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{height: \"100%\", width: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "FormField",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-FormField-2"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "value",
          "value": "16"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "label",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติ รคส.",
          "valueEN": "History of Verbal Order"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-label-3"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"16px\", padding :\"10px\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-FormField-7"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.editorSearch"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-FormGroup-14"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-FormField-19"
        },
        "width": {
          "type": "value",
          "value": "1"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "FormField",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-FormField-30"
        },
        "width": {
          "type": "value",
          "value": "7"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 31,
      "name": "div",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-div-31"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", display: \"flex\", justifyContent: \"space-evenly\", alignItems: \"center\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Checkbox",
      "parent": 31,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.selectedOrder?.includes(\"ADMIT_ORDER\")"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-Checkbox-32"
        },
        "label": {
          "type": "value",
          "value": "Admit",
          "valueEN": "Admit"
        },
        "name": {
          "type": "value",
          "value": "ADMIT_ORDER"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSelectedOrder"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "Checkbox",
      "parent": 31,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.selectedOrder?.includes(\"DRUG_ORDER\")"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-Checkbox-33"
        },
        "label": {
          "type": "value",
          "value": "ยา",
          "valueEN": "Drug"
        },
        "name": {
          "type": "value",
          "value": "DRUG_ORDER"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSelectedOrder"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 34,
      "name": "Checkbox",
      "parent": 31,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.selectedOrder?.includes(\"LAB_ORDER\")"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-Checkbox-34"
        },
        "label": {
          "type": "value",
          "value": "แล็บ",
          "valueEN": "Lab"
        },
        "name": {
          "type": "value",
          "value": "LAB_ORDER"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSelectedOrder"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Checkbox",
      "parent": 31,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.selectedOrder?.includes(\"TREATMENT_ORDER\")"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-Checkbox-35"
        },
        "label": {
          "type": "value",
          "value": "หัตถการ",
          "valueEN": "Treatment"
        },
        "name": {
          "type": "value",
          "value": "TREATMENT_ORDER"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSelectedOrder"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "Checkbox",
      "parent": 31,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.selectedOrder?.includes(\"OR_ORDER\")"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-Checkbox-36"
        },
        "label": {
          "type": "value",
          "value": "ผ่าตัด",
          "valueEN": "Surgery"
        },
        "name": {
          "type": "value",
          "value": "OR_ORDER"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSelectedOrder"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 37,
      "name": "Table",
      "parent": 0,
      "props": {
        "data": {
          "type": "code",
          "value": "props.historyData"
        },
        "getTrProps": {
          "type": "code",
          "value": "props.rowProps"
        },
        "headers": {
          "type": "value",
          "value": "Patient,Order Date,Type,Status,Description,ผู้บันทึกคำสั่งแทน,co-signed,co-signed Time,หมายเหตุ,"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-Table-37"
        },
        "keys": {
          "type": "value",
          "value": "patient_summary,created,order_specific_label,specific_status,description,order_receive_by_name,co_signed,co_signed_time,ack_comments,_action"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{maxHeight: \"50vh\"}"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-FormField-38"
        },
        "width": {
          "type": "value",
          "value": "1"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 38,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้บันทึก",
          "valueEN": "Recorder"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\",textAlign: \"center\",}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-FormField-40"
        },
        "width": {
          "type": "value",
          "value": "1"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 40,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่",
          "valueEN": "Date"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\", width: \"100%\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-FormField-42"
        },
        "inline": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 44,
      "name": "DateTextBox",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-DateTextBox-44"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeStartDate"
        },
        "value": {
          "type": "code",
          "value": "props.startDate"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-FormField-45"
        },
        "width": {
          "type": "value",
          "value": "1"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\", width: \"100%\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-FormField-47"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 49,
      "name": "DateTextBox",
      "parent": 48,
      "props": {
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-DateTextBox-49"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeEndDate"
        },
        "value": {
          "type": "code",
          "value": "props.endDate"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "code",
          "value": "props.haveEncounter ? \"\" : \"one wide field\""
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-div-50"
        },
        "style": {
          "type": "code",
          "value": "{display: props.haveEncounter? \"none\": \"block\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "code",
          "value": "props.haveEncounter ? \"\" : \"three wide field\""
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{display: props.haveEncounter? \"none\": \"block\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "code",
          "value": "props.optionSearch"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-div-52"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", display: props.haveEncounter?  \"none\": \"block\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "Dropdown",
      "parent": 50,
      "props": {
        "disabled": {
          "type": "code",
          "value": ""
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-Dropdown-53"
        },
        "onChange": {
          "type": "code",
          "value": "props.changeSelectedSearch"
        },
        "options": {
          "type": "code",
          "value": "props.optionsSearch"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.haveEncounter?  \"none\": \"block\"}"
        },
        "value": {
          "type": "code",
          "value": "props.selectedSearch"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 19,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardVerbalOrderHistoryUX-div-54"
        }
      },
      "seq": 54,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardVerbalOrderHistoryUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
